import styled from 'styled-components';

export const IconSpan = styled.span`
  display: flex;
  pointer-events: all;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  justify-content: center;
`;

export const IconDiv = styled.div`
  display: flex;
`;
